import { FC, ReactNode } from 'react';
import { observer } from 'mobx-react-lite';
import { Skeleton } from 'components';
import { Text, VStack } from 'components/ui';
import { Container, RequiredMark } from './styled';

type SegmentProps = {
  title: string;
  description?: string | ReactNode;
  content: ReactNode;
  isRequired?: boolean;
};

export const Segment: FC<SegmentProps> = observer(
  ({ title, description, content, isRequired = false }) => {
    return (
      <Container>
        <VStack spacing="xs">
          <Text variant="heading-4" color="gray.500">
            {title}
            {isRequired ? <RequiredMark>*</RequiredMark> : null}
          </Text>
          {typeof description === 'string' ? (
            <Text variant="body-14" color="gray.500">
              {description}
            </Text>
          ) : (
            <div>{description}</div>
          )}
        </VStack>
        <div>{content}</div>
      </Container>
    );
  }
);

export const SegmentSkeleton: FC<Partial<Pick<SegmentProps, 'content'>>> = ({
  content,
}) => {
  return (
    <Container>
      <VStack spacing={'xs'}>
        <Skeleton width="200px" height="20px" />
      </VStack>
      <div>{content || <Skeleton width="100%" height="84px" />}</div>
    </Container>
  );
};
